// import something here
import { Platform } from 'quasar'

import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  projectId: process.env.FIREBASE_PROJECT_ID,
  apiKey: process.env.FIREBASE_KEY,
  messagingSenderId: process.env.MESSAGING_ID,
  appId: process.env.FIREBASE_APP_ID,
  authDomain: 'termiteregister-48ac9.firebaseapp.com'
}

export let serviceWorker = null

// leave the export, even if you don't use it
export default async () => {
  initializeApp(firebaseConfig)
  if ('serviceWorker' in navigator && !Platform.is.nativeMobile && !Platform.is.ios) {
    try {
      serviceWorker = await navigator.serviceWorker.register('firebase-messaging-sw.js')
    }
    catch (err) {
      console.log('ServiceWorker registration failed: ', err)
    }
  }
}
